import { CLIENT_PANEL_AUTHENTICATION, CLIENT_PANEL_AUTHENTICATION_SUCCESS, CLIENT_PANEL_AUTHENTICATION_ERROR, CLIENT_PANEL_AUTHENTICATION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientPanelAuthentication = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_PANEL_AUTHENTICATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_PANEL_AUTHENTICATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_PANEL_AUTHENTICATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_PANEL_AUTHENTICATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientPanelAuthentication;
